const cache = {};

export const getStationName = async (api, nlc) => {
  const endpoint = `/stations/${nlc}`;
  let response;
  
  if (!cache[endpoint]) {
    try {
      response = await api.get(endpoint);
      cache[endpoint] = response;
    } catch (err) {
      console.warn(err);
    }
  } else {
    response = cache[endpoint];
  }

  return response.data.result.name;
};

export const getTicketTypeName = async (api, ticketTypeCode) => {
  let response;
  const endpoint = `/ticket-types/${ticketTypeCode}`;

  if (!cache[endpoint]) {
    try {
      response = await api.get(endpoint);
      cache[endpoint] = response;
    } catch (err) {
      console.warn(err);
    }
  } else {
    response = cache[endpoint];
  }
  
  return response.data.result.name;
};

export const getRailcardName = async (api, railcardCode) => {
  let response;
  const endpoint = `/railcards/${railcardCode}`;

  if (!cache[endpoint]) {
    try {
      response = await api.get(endpoint);
      cache[endpoint] = response;
    } catch (err) {
      console.warn(err);
    }
  } else {
    response = cache[endpoint];
  }
  
  return response.data.result.name;
};
